// Kaizen Dashboard layouts
import Remitos from "layouts/remitos";
import Recepcion from "layouts/recepcion";
import Remito from "layouts/remito";
import BadgeIcon from "@mui/icons-material/Badge";
import { Hail, MoveToInbox, Receipt, SwapHoriz } from "@mui/icons-material";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ErrorHandler from "components/ErrorHandler";
import { rolesConAcceso } from "services/config";
import PDF from "layouts/pdf";

const routes = [
  {
    type: "collapse",
    name: "Remitos",
    key: "remitos",
    route: "/remitos",
    icon: <Receipt />,
    component: <Remitos />,
    access: ["5"],
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Recepción",
    key: "recepcion",
    route: "/recepcion",
    icon: <MoveToInbox />,
    component: <Recepcion />,
    access: ["5"],
    noCollapse: true,
  },
  {
    component: <PDF />,
    route: "/pdf/:id",
  },
  {
    route: "/login",
    component: <SignIn />,
  },
  {
    route: "/remito",
    component: <Remito />,
  },
  {
    route: "/remito/:id",
    component: <Remito />,
  },
  {
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    route: "/error",
    component: <ErrorHandler />,
    access: rolesConAcceso,
  },
];

export default routes;
